export default (props, vars) => () =>
  props?.['onOpenProfile'](props?.['student'].id);
